import { useMemo } from "react";
import { OperationContext } from "urql";

import { getOperationContext, IGetOperationContextOpts } from "../utils/urql/getOperationContext";

export type IUseOperationContextOpts<Operation> = IGetOperationContextOpts<Operation>;

export function useOperationContext<Operation>(opts: IUseOperationContextOpts<Operation>): Partial<OperationContext> {
    return useMemo((): Partial<OperationContext> => getOperationContext(opts), [opts]);
}
